import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Center,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Heading,
  Input,
  InputGroup,
  InputRightElement,
  useToast,
} from "@chakra-ui/react";
import isEqual from "lodash/isEqual";
import { useEffect, useState } from "react";
import API from "../api";

const PersonalDetails = ({ data, setData }) => {
  const toast = useToast();
  const [isOpenAccordion, setIsOpenAccordion] = useState(true);
  const defaultConfig = {
    name: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
    companyName: "",
  };

  const [config, setConfig] = useState(data ?? defaultConfig);
  const [errors, setErrors] = useState({});
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [showPassword, setShowPassword] = useState();
  const [loading, setLoading] = useState(false);

  const updatePersonalDetails = async () => {
    setLoading(true);
    const bodyData = { ...config };
    delete bodyData.confirmPassword;
    delete bodyData.uniquePartnerId;
    await API("/partner/update-partner", "POST", bodyData)
      .then((data) => {
        if (data) {
          console.log(data);
          setConfig(bodyData);
          delete bodyData.password;
          setData(bodyData);
          setLoading(false);
        }
      })
      .catch((err) => {
        toast({
          title: "Error in fetching data!",
          description: err?.error ?? "Internal Server Error!",
          status: "error",
          duration: 2000,
          isClosable: true,
        });
        console.log("error", err);
      });
  };

  const updateConfig = (key) => (value) => {
    if (errors[key]) {
      const errorObj = { ...errors };
      delete errorObj[key];
      setErrors({ ...errorObj });
    }
    if (key === "phone") {
      const updatedValue = value?.target?.value?.replace(/^0+|[^0-9]/g, "");
      setConfig({
        ...config,
        [key]: updatedValue,
      });
    } else {
      setConfig({
        ...config,
        [key]: value?.target?.value ?? "",
      });
    }
  };

  const validateConfig = (config) => {
    let objErrors = {};
    if (config.name === "" || !config.name) {
      objErrors.name = "Name is required";
    } else if (
      config.phone === "" ||
      !config.phone ||
      config?.phone?.length !== 10
    ) {
      objErrors.phone = "Valid Phone Number is required";
    } else if (config.email === "" || !config.email) {
      objErrors.email = "Email is required";
    } else if (
      (!config.password || config.password === "") &&
      config.confirmPassword !== "" &&
      !!config.confirmPassword
    ) {
      objErrors.password = "Password is required";
    } else if (
      (!config.confirmPassword || config.confirmPassword === "") &&
      config.password !== "" &&
      !!config.password
    ) {
      objErrors.confirmPassword = "Confirm Password is required";
    } else if (config.confirmPassword !== config.password) {
      objErrors.confirmPassword = "Wrong Confirm Password";
    } else {
      objErrors = {};
    }
    return objErrors;
  };

  const handleFormSubmit = async () => {
    console.log("=-=-=-=-=-=", config);
    const objErrors = { ...errors, ...validateConfig(config) };
    if (Object.keys(objErrors).length > 0) {
      console.log("objErrors", objErrors);
      setErrors(objErrors);
      toast({
        title: "Form Field Errors",
        description: "Please fill the fields correctly!",
        status: "error",
        duration: 2000,
        isClosable: true,
      });
    } else {
      await updatePersonalDetails();
      toast({
        title: "Form Field Errors",
        description: " Fields are filled correctly!",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
    }
  };
  const handleShowPassword = (value) => {
    if (value === "password") {
      setShowPassword(showPassword === "password" ? null : "password");
    } else {
      setShowPassword(
        showPassword === "confirmPassword" ? null : "confirmPassword"
      );
    }
  };

  const handleCancel = () => {
    setConfig(data);
  };

  useEffect(() => {
    if (!isEqual(data, config)) {
      setUnsavedChanges(true);
    } else {
      setUnsavedChanges(false);
    }
  }, [config]);

  return (
    <div
      className="form-box"
      style={{
        backgroundColor: "white",
        padding: "20px",
        borderRadius: "10px",
        boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.2)",
        marginTop: "20px",
      }}
    >
      <Accordion
        allowMultiple
        defaultIndex={isOpenAccordion ? [0] : []}
        index={isOpenAccordion ? [0] : []}
      >
        <AccordionItem>
          <AccordionButton onClick={() => setIsOpenAccordion(!isOpenAccordion)}>
            <Box as="span" flex="1" textAlign="left">
              <Center>
                <Heading as="h3" size="lg">
                  Update Personal Details
                </Heading>
              </Center>
            </Box>
            <AccordionIcon />
          </AccordionButton>

          <AccordionPanel pb={4}>
            <FormControl isRequired isInvalid={errors?.name ? true : false}>
              <FormLabel htmlFor="first-name" fontWeight={"normal"}>
                Name
              </FormLabel>
              <Input
                id="first-name"
                placeholder="Name"
                onChange={updateConfig("name")}
                name="name"
                value={config?.name}
              />
              {errors?.name ? (
                <FormErrorMessage>{errors?.name}</FormErrorMessage>
              ) : (
                <></>
              )}
            </FormControl>

            <FormControl mt="2%" isInvalid={errors?.companyName ? true : false}>
              <FormLabel htmlFor="company-name" fontWeight={"normal"}>
                Company Name
              </FormLabel>
              <Input
                id="company-name"
                placeholder="Company Name"
                onChange={updateConfig("companyName")}
                name="companyName"
                value={config?.companyName}
              />
              {errors?.companyName ? (
                <FormErrorMessage>{errors?.companyName}</FormErrorMessage>
              ) : (
                <></>
              )}
            </FormControl>

            <FormControl mt="2%">
              <FormLabel htmlFor="email" fontWeight={"normal"}>
                Email address
              </FormLabel>
              <Input
                id="email"
                type="email"
                onChange={updateConfig("email")}
                name="email"
                value={config?.email}
              />
              {errors?.email ? (
                <FormErrorMessage>{errors?.email}</FormErrorMessage>
              ) : (
                <></>
              )}
            </FormControl>

            <FormControl mt="2%" isInvalid={errors?.phone ? true : false}>
              <FormLabel htmlFor="email" fontWeight={"normal"}>
                Phone No.
              </FormLabel>
              <Input
                id="phone"
                type="number"
                onChange={updateConfig("phone")}
                name="phone"
                value={config?.phone}
              />
              {errors?.phone ? (
                <FormErrorMessage>{errors?.phone}</FormErrorMessage>
              ) : (
                <></>
              )}
            </FormControl>

            <FormControl
              isInvalid={
                errors?.password || errors?.confirmPassword ? true : false
              }
            >
              <FormLabel htmlFor="password" fontWeight={"normal"} mt="2%">
                Password
              </FormLabel>
              <InputGroup size="md">
                <Input
                  pr="4.5rem"
                  type={showPassword === "password" ? "text" : "password"}
                  placeholder="Enter password"
                  onChange={updateConfig("password")}
                  name="password"
                  value={config?.password}
                />
                <InputRightElement width="4.5rem">
                  <Button
                    h="1.75rem"
                    size="sm"
                    onClick={() => handleShowPassword("password")}
                  >
                    {"Show"}
                  </Button>
                </InputRightElement>
              </InputGroup>
              {errors?.password ? (
                <FormErrorMessage>{errors?.password}</FormErrorMessage>
              ) : (
                <></>
              )}

              <FormLabel
                htmlFor="confirm-password"
                fontWeight={"normal"}
                mt="2%"
              >
                Confirm Password
              </FormLabel>
              <InputGroup size="md">
                <Input
                  pr="4.5rem"
                  type={
                    showPassword === "confirmPassword" ? "text" : "password"
                  }
                  placeholder="Enter password"
                  name="confirmPassword"
                  value={config?.confirmPassword}
                  onChange={updateConfig("confirmPassword")}
                />
                <InputRightElement width="4.5rem">
                  <Button
                    h="1.75rem"
                    size="sm"
                    onClick={() => handleShowPassword("confirmPassword")}
                  >
                    {"Show"}
                  </Button>
                </InputRightElement>
              </InputGroup>
              {errors?.confirmPassword ? (
                <FormErrorMessage>{errors?.confirmPassword}</FormErrorMessage>
              ) : (
                <></>
              )}
            </FormControl>
            {unsavedChanges ? (
              <>
                <br /> <br />{" "}
                <Center>
                  <Button onClick={handleCancel} mr={"10"} colorScheme="yellow">
                    Cancel Changes
                  </Button>
                  <Button onClick={handleFormSubmit} colorScheme="red">
                    Save Changes
                  </Button>
                </Center>
              </>
            ) : (
              <></>
            )}
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default PersonalDetails;
